import { EboObjectTimeLineTO } from '../../base-classes/ebo-object-time-line-to';
import { Employee } from '../employee';
import { EmployeeStatus } from './employee-status.enum';

export class EmployeeStatusHistory extends EboObjectTimeLineTO {
  employeeID: string;
  employee: Employee;
  status: EmployeeStatus;
  doNotRehire: boolean;

  constructor(json?: Partial<EmployeeStatusHistory>) {
    super(json);
    if (json) {
      if (json.employee) this.employee = new Employee(json?.employee);
    }
    this.status ??= EmployeeStatus.FullTime;
    this.doNotRehire ??= false;
  }

  get rehireText(): string {
    if (this.status !== EmployeeStatus.Disabled) return undefined;
    return this.doNotRehire ? 'No' : 'Yes';
  }
}
